"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let ExchangeRateDateRule = class ExchangeRateDateRule extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    item;
    onItem(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("item");
    }
    editing;
    onEditing(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("editing");
    }
    labelColsMd;
    onLabel_cols_md(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("labelColsMd");
    }
    contentColsMd;
    onContent_cols_md(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("contentColsMd");
    }
    labelAlign;
    metadata;
    async $$load_metadata() {
        return this.$app.repo.get('ui_metadata');
    }
    ux;
    dataMembers = ['labelAlign', 'metadata', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                labelAlign: "right",
                metadata: null,
                ux: null,
            },
        };
    }
    get referenceMonthOptions() {
        if (this.loaded) {
            return this.metadata.exchange_rate_date_reference_month_options;
        }
        return null;
    }
    get daySpecifierOptions() {
        if (this.loaded) {
            return this.metadata.exchange_rate_date_day_specifier_options;
        }
        return null;
    }
    get target() {
        if (this.loaded) {
            return this.item;
        }
        return null;
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_2398 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_2397 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_2398,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_2397],
        });
        return {
            act_7315092382398562_reloadComponentData_2398,
            evh_7315092382398562_reload_2397,
            evh_7315092382398562_reload,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], ExchangeRateDateRule.prototype, "item", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('item'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ExchangeRateDateRule.prototype, "onItem", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], ExchangeRateDateRule.prototype, "editing", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('editing'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ExchangeRateDateRule.prototype, "onEditing", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        default: 3,
    }),
    __metadata("design:type", Object)
], ExchangeRateDateRule.prototype, "labelColsMd", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('labelColsMd'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ExchangeRateDateRule.prototype, "onLabel_cols_md", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        default: 9,
    }),
    __metadata("design:type", Object)
], ExchangeRateDateRule.prototype, "contentColsMd", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('contentColsMd'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ExchangeRateDateRule.prototype, "onContent_cols_md", null);
ExchangeRateDateRule = __decorate([
    (0, vue_property_decorator_1.Component)()
], ExchangeRateDateRule);
exports.default = ExchangeRateDateRule;
vue_property_decorator_1.Vue.component("ExchangeRateDateRule", ExchangeRateDateRule);
